const Comment = () => {
  return (
    <svg
      aria-hidden="true"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 0H1.66667C1.22464 0 0.800716 0.189033 0.488155 0.525514C0.175595 0.861995 0 1.31836 0 1.79422V10.7653C0 11.2412 0.175595 11.6975 0.488155 12.034C0.800716 12.3705 1.22464 12.5595 1.66667 12.5595H4.32333C5.15667 12.5595 5.83333 13.2871 5.83333 14.1851C5.83333 14.9099 6.64667 15.2724 7.1225 14.7601L8.67833 13.0852C8.99082 12.7487 9.41467 12.5596 9.85667 12.5595H13.3333C13.7754 12.5595 14.1993 12.3705 14.5118 12.034C14.8244 11.6975 15 11.2412 15 10.7653V1.79422C15 1.31836 14.8244 0.861995 14.5118 0.525514C14.1993 0.189033 13.7754 0 13.3333 0Z"
        fill="#999999"
      />
    </svg>
  )
}

export default Comment
